type GoogleLogoProps = {
  className?: string;
};

function GoogleLogo({ className = "h-5 w-5" }: GoogleLogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="#4285f4"
        d="M44.5 20H24v8.5h11.9A12 12 0 1 1 24 12a11.7 11.7 0 0 1 8.3 3.2l6-6.2A20 20 0 1 0 44 24a21 21 0 0 0-.5-4z"
      />
      <path
        fill="#34a853"
        d="M6 14.7l6.6 4.8A12 12 0 0 1 24 12v-8a20 20 0 0 0-18 10.7z"
      />
      <path
        fill="#fbbc04"
        d="M24 44a20 20 0 0 0 13.8-5.4L31 33.5a12 12 0 0 1-18-4.9l-7 5.5A20 20 0 0 0 24 44z"
      />
      <path
        fill="#ea4335"
        d="M44.5 20H24v8.5h11.9a12 12 0 0 1-4.2 5.1L37.8 38A20 20 0 0 0 44.5 24a21 21 0 0 0-.5-4z"
      />
    </svg>
  );
}

export default GoogleLogo;
